import {
  AccessibleSelect,
  InputControl,
  Tag,
  tailwindMerge,
} from "@growtherapy/sprout-ui";

import { BASE_DURATION_OPTIONS } from "./constants";

interface DurationInputProps {
  "data-testid"?: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (duration: number) => void;
  value: number;
  className?: string;
  readonly?: boolean;
  durationOptions?: { label: string; value: string }[];
}

export const DurationInput = ({
  "data-testid": dataTestId,
  disabled = false,
  error = false,
  onChange,
  value,
  className,
  readonly = false,
  durationOptions = BASE_DURATION_OPTIONS,
}: DurationInputProps): JSX.Element => {
  return (
    <InputControl
      className={tailwindMerge("w-full", className)}
      labelClassName="text-neutral-800 text-medium pt-1 font-normal"
      label="Duration"
      supplementalInfoLayoutClass="mb-0 !justify-start py-px bottom-auto "
      supplementalInfo={
        <Tag
          className="relative bottom-1 inline-flex items-center"
          data-testid="duration-new-tag"
        >
          New
        </Tag>
      }
    >
      <AccessibleSelect
        data-testid={dataTestId}
        disabled={disabled}
        error={error}
        onChange={(newValue: string): void => onChange(Number(newValue))}
        options={durationOptions}
        readonly={readonly}
        value={value.toString()}
      />
    </InputControl>
  );
};
